import { constants } from '../config';

export const getLineServices = (lineUuid) => ({
  type: constants.GET_LINE_SERVICES,
  lineUuid,
});

export const getLineServicesSuccess = (data) => ({
  type: constants.GET_LINE_SERVICES_SUCCESS,
  payload: data,
});

export const getLineServicesError = (error) => ({
  type: constants.GET_LINE_SERVICES_ERROR,
  payload: error,
});

export const getLineServiceDetail = (lineUuid, serviceSlug) => ({
  type: constants.GET_LINE_SERVICE_DETAIL,
  lineUuid,
  serviceSlug,
});

export const getLineServiceDetailSuccess = (data) => ({
  type: constants.GET_LINE_SERVICE_DETAIL_SUCCESS,
  payload: data,
});

export const getLineServiceDetailError = (error) => ({
  type: constants.GET_LINE_SERVICE_DETAIL_ERROR,
  payload: error,
});
